import './ViewLocationInfo.scss';
import ViewLocationInfo from "./ViewLocationInfo";

export default ViewLocationInfo;